import { UNION, OP } from './src/constants';

const UNKNOWN_TYPE = ''; // Desde filterEdiwin, no podemos saber de que tipo de filtro se trata.

/**
 * mapea un filterEdiwin -> filterModel
 * OJO: como no se puede adivinar el tipo, lo dejara blanco = ''
 * @param {object} filter
 * @returns
 */
export function mapFilterEdiwinToFilterModel(filterEdiwin) {
  const type = UNKNOWN_TYPE;
  if (filterEdiwin.filterCriteria.criteria) {
    throw new Error(
      `get filterModel: el objeto filterModel no puede tratar "criteria" de primer nivel del objeto filter`
    );
  }

  return filterEdiwin.filterCriteria.children.reduce((acc, { criteria, children, union }) => {
    if (!criteria) {
      throw new Error(`get filterModel: criteria obligatorio a nivel de childrens`);
    }
    const { v1, op: condition, v2 } = criteria;
    if (children && children.length) {
      throw new Error(`get filterModel: el objeto filterModel no puede tratar children de childrens, solo un nivel`);
    }
    if (union && !UNION.ANDS.includes(union)) {
      throw new Error(`get filterModel: union="${union}" debe ser siempre AND y null para el utlimo`);
    }
    acc[v1] = acc[v1] || {};
    acc[v1][type] = acc[v1][type] || [];

    if ([OP.IN, OP.NOT_IN].includes(condition)) {
      // transformamos una lista con separador "," en array
      let value = typeof v2 === 'string' ? v2.split(',') : [];
      if (value.every(v => `${parseFloat(v)}` === v)) {
        value = value.map(v => parseFloat(v));
      }

      acc[v1][type].push({ condition, value });
    } else {
      acc[v1][type].push({ condition, value: v2 });
    }
    return acc;
  }, {});
}
